import { useAppDispatch, useAppSelector } from 'app/hooks';
import { getHoliday, selectHolidaysInMonth } from 'features/dashboard/dashboardSlice';
import { IHoliday } from 'hrm-common/extensions/interfaces/personel';
import moment, { Moment } from 'moment';
import { useEffect, useRef, useState } from 'react';
import { transMomentTimezone } from 'utils/date';
import { DescriptionHoliday, DescriptionItemHoliday } from './HeadersStyles';

const DescriptionHolidayHeader = () => {
  const dispatch = useAppDispatch();
  const holidayDivWrapperRef = useRef<HTMLDivElement | null>(null);
  const holidaySpanRef = useRef<HTMLSpanElement | null>(null);
  const [widthHolidayWrapper, setWidthHolidayWrapper] = useState<number>(0);
  const [today, setToday] = useState<Moment>(transMomentTimezone());
  const holidaysInMonth: IHoliday[] = useAppSelector(selectHolidaysInMonth);
  const holidayToday: IHoliday | (IHoliday & { description: string }) | undefined =
    holidaysInMonth.find(
      (item: IHoliday) =>
        moment(item.startTime).startOf('day').set({ year: moment().year() }) <= today &&
        moment(item.endTime).endOf('day').set({ year: moment().year() }) >= today,
    );
  useEffect(() => {
    const { current: holidayWrapper } = holidayDivWrapperRef;
    let timeIntervalToday: NodeJS.Timeout;

    const resizeHolidayWrapper = () => {
      setWidthHolidayWrapper(holidayWrapper?.clientWidth || 0);
    };

    window.addEventListener('resize', resizeHolidayWrapper);

    timeIntervalToday = setInterval(() => {
      setToday(transMomentTimezone());
    }, 10000);

    dispatch(
      getHoliday({ month: moment().month() + 1, year: moment().year(), isCurrentMonth: true }),
    );

    return () => {
      clearInterval(timeIntervalToday);
      window.removeEventListener('resize', resizeHolidayWrapper);
    };
  }, [dispatch]);

  return (
    <>
      {holidayToday && (
        <DescriptionHoliday ref={holidayDivWrapperRef}>
          <DescriptionItemHoliday
            ref={holidaySpanRef}
            widthHolidayWrapper={
              widthHolidayWrapper || holidayDivWrapperRef.current?.clientWidth || 0
            }
            widthHoliday={holidaySpanRef.current?.clientWidth || 0}
          >
            {holidayToday?.description || 'Hôm nay là ngày lễ đặc biệt'}
          </DescriptionItemHoliday>
        </DescriptionHoliday>
      )}
    </>
  );
};

export default DescriptionHolidayHeader;
